export const TableGridRowSelected =
  'cursor-pointer border-b-[1px] data-[state=selected]:border-[#E7EAEC] data-[state=selected]:bg-[#FEF4F6]';

export const TableGridRowHover = 'cursor-pointer  hover:bg-[#FEF4F6]';
export const TableGridCellIcon = 'text-[#3E5A6A]';
